import { GET_APP_LINK } from '@/modules/branch/constants';
import {
  APP_DOWNLOAD_PLACEMENTS,
  type AppDownloadPlacement,
  type AppDownloadPlacementEntry,
} from '@/modules/branch/placements';
import { useBranchDeepLink } from '@/modules/externalTracking/useBranchDeepLink';

type Props = {
  placement: AppDownloadPlacement;
  variant?: 'qr_code' | 'download_button';
  sourceId?: string;
};

export function useAppDownloadDeepLink({
  placement,
  variant = 'qr_code',
  sourceId,
}: Props): string {
  const entry: AppDownloadPlacementEntry = APP_DOWNLOAD_PLACEMENTS[placement];

  return useBranchDeepLink({
    fallback: entry.fallback ?? GET_APP_LINK,
    appPath: entry.appPath ?? '/',
    stage: entry.stage,
    feature: entry.feature,
    campaign: entry.campaign,
    channel: 'website',
    referrerSource: `${variant}__${sourceId ?? placement}`,
  });
}
